module.exports = __webpack_public_path__ + "media/images/emblems/WappenArbon-6ddf1774b6a1d02f6678e7e4ca472e8e.png";